import { queryKeys } from "@/queryKeys";
import { borrowerService } from "@/services/borrowers";

export const BORROWER_DETAIL_STALE_MS = 30_000;

/** Shared options for `useBorrowerQuery` and `prefetchQuery` so cache keys and staleness stay aligned. */
export function borrowerDetailQueryOptions(id: number) {
  return {
    queryKey: queryKeys.borrower(id),
    queryFn: () => borrowerService.getById(id),
    staleTime: BORROWER_DETAIL_STALE_MS,
  };
}
